import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Custom hook that calls a function (fn) when the URL path changes or dependencies update
const usePageChange = (fn, deps) => {
  const location = useLocation(); // Get the current location object

  useEffect(() => {
    fn(); // Call the function
  }, [location.pathname].concat(deps)); // Trigger when URL path or dependencies change
};

export default usePageChange;
